import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(
    private apiService: ApiService
  ) { }

  fetchSetting(currentUser) {
    if (currentUser) {
      return this.apiService.get(
        API_ENDPOINTS.BASE_URL +
        API_ENDPOINTS.VERSION +
        API_ENDPOINTS.API.USERS +
        '/' + currentUser.user.id +
        API_ENDPOINTS.API.PROFILE_SETTINGS);
    }
  }

  deleteAcc(params){
    return this.apiService.patch(`${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.DEACTIVATE_ACC}`, params);
  }

  checkPassword(params){
    return this.apiService.post(`${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.API.CHECK_PASSWORD}`, params);
  }

  updateSetting(type, settingData, currentUser) {
    if (currentUser) {
      return this.apiService.put(
        API_ENDPOINTS.BASE_URL +
        API_ENDPOINTS.VERSION +
        API_ENDPOINTS.API.USERS +
        '/' + currentUser.user.id +
        API_ENDPOINTS.API.PROFILE_SETTINGS +
        '/' + type, settingData);
    }
  }

  updatePassword(params) {

    return this.apiService.put(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.USERS +
      API_ENDPOINTS.API.CHANGE_PASSWORD, params);
  }

  updatePhone(params, userId) {
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.USERS +
      '/' + userId, params);
  }

  updateConnectionSettings(params, userId) {
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.USERS +
      '/' + userId +
      API_ENDPOINTS.API.PROFILE_SETTINGS +
      API_ENDPOINTS.API.CHANGE_PRIVACY_SETTING, params);
  }

  fetchBlockedConnection() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.FETCH_BLOCKED_CONNECTIONS);

  }

  fetchBlockedContentAndConnection(){
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.FETCH_BLOCKED_CONTENT_AND_CONNECTION);
  }

  unblockConnection(userId, params) {
    return this.apiService.patch(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.CONNECTIONS + '/' + userId, params);

  }

  unblockContentAndConnection(params){
    return this.apiService.delete(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.FETCH_BLOCKED_CONTENT_AND_CONNECTION +
      API_ENDPOINTS.API.UNBLOCK_CONTENT_AND_CONNECTION , params);
  }

  savePublicProfileAdvertisement(params) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION + API_ENDPOINTS.API.PUBLIC_PROFILE_ADVERTISEMENTS, params)
  }
  saveMaterialProfileAdvertisement(params) {
    return this.apiService.post(API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION + API_ENDPOINTS.API.MATERIAL_PROMOTION, params)
  }
  fetchAdvertisementOwendByMe() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.ADVERTISEMENT + '/adv_owned_by_me')

  }
  fetchAdvertisementOwendByOthers() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.ADVERTISEMENT + '/adv_owned_by_others')

  }
  acceptRejectAdvertisement(param){
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.ADVERTISEMENT + API_ENDPOINTS.API.ADVERTISEMENT_ACCEPT_REJECT,param);
  }
  cancelAdvertisement(param){
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.ADVERTISEMENT + `/${param}`+ API_ENDPOINTS.API.CANCEL_ADVERTISEMENT);
  }
  fetchPublicSpaceOwned() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.PUBLIC_PROFILE_ADVERTISEMENTS +
      API_ENDPOINTS.API.OWNED_PUBLIC_ADVERTISEMENT
    )
  }


  fetchMaterialAdsOwned() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.MATERIAL_PROMOTION +
      API_ENDPOINTS.API.OWNED_PUBLIC_ADVERTISEMENT
    )
  }

  // fetchMaterialAdsAmound() {
  //   return this.apiService.get(
  //     API_ENDPOINTS.BASE_URL +
  //     API_ENDPOINTS.VERSION +
  //     API_ENDPOINTS.API.PUBLIC_PROFILE_ADVERTISEMENTS +
  //     API_ENDPOINTS.API.OWNED_PUBLIC_ADVERTISEMENT
  //   )
  // }

  verificationRequestStatus(userId) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.BUSINESS_PROFILE +
      API_ENDPOINTS.API.USER_VERIFICATION_DETAIL + '/' + userId)
  }

  fetchMyContent(){
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION  +
      API_ENDPOINTS.API.MY_CONTENT)
  }
}
